import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { isMobileAuthFlow, redirectToMobileApp } from "../auth/mobileAuth";
import { useTranslation } from "react-i18next";

/**
 * Abschluss des OAuth-Logins: tauscht den Einmal-Code aus der URL gegen eine
 * Session und leitet ins Dashboard weiter. Bei Fehlern zurück zum Login.
 */
export default function OAuthCallback() {
  const { t } = useTranslation();
  const { loginWithOAuthCode } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState(null);
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) {
      return;
    }
    ranRef.current = true;

    const code = searchParams.get("code");
    const providerError = searchParams.get("error");

    if (providerError || !code) {
      setError(providerError || "oauth_failed");
      const timer = setTimeout(() => {
        navigate("/login", { replace: true, state: { oauthError: providerError || "oauth_failed" } });
      }, 2500);
      return () => clearTimeout(timer);
    }

    // App-Login-Flow: Einmal-Code an die App uebergeben (kein SPA-Login).
    if (isMobileAuthFlow()) {
      redirectToMobileApp(code);
      return;
    }

    loginWithOAuthCode(code)
      .then(() => {
        navigate("/dashboard", { replace: true });
      })
      .catch(() => {
        setError("oauth_failed");
        setTimeout(() => {
          navigate("/login", { replace: true, state: { oauthError: "oauth_failed" } });
        }, 2500);
      });
  }, [loginWithOAuthCode, navigate, searchParams]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        gap: "12px",
        fontFamily: "system-ui, -apple-system, sans-serif",
        color: "#444",
        textAlign: "center",
        padding: "24px",
      }}
    >
      {error ? (
        <p>{t("auth.oauth.error")}</p>
      ) : (
        <p>{t("auth.oauth.completing")}</p>
      )}
    </div>
  );
}
